import type Decimal from "decimal.js";

export const toFixed = (
  value?: number | string | Decimal | null,
  precision?: number,
) => {
  value = Number(value ?? 0);
  if (!value) return 0;
  if (!precision) return Math.round(value);

  const power = Math.pow(10, precision || 0);
  return Math.round(value * power) / power;
};

export const formatNumber = (value: number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0, // 최소 소수점 자릿수
    maximumFractionDigits: 18, // 최대 소수점 자릿수
  });

  return formatter.format(value);
};
